// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  actGetBrandsPending: false,
  actGetBrandsError: null,
  brands: [],
  actGetModelsPending: false,
  actGetModelsError: null,
  models: [],
  actGetYearsPending: false,
  actGetYearsError: null,
  years: [],
  actGetVersionsPending: false,
  actGetVersionsError: null,
  versions: [],
  actPostQuotationNewPending: false,
  actPostQuotationNewError: null,
  quotationsList: [],
  actGetQuotationsPending: false,
  actGetQuotationsError: null,
  actGetSegmentsPending: false,
  actGetSegmentsError: null,
  segments: [],
  actGetAntiquitiesPending: false,
  actGetAntiquitiesError: null,
  antiquities: [],
  newQuoteResponse: {},
  editing: false,
  quoteEditing: {},
  getVehiclesSegmentPending: false,
  getVehiclesSegmentError: null,
  vehicles: [],
  actPostSegmentPending: false,
  actPostSegmentError: null,
  actDeleteSegmentPending: false,
  actDeleteSegmentError: null,
  actUpdateSegmentPending: false,
  actUpdateSegmentError: null,
  actUpdateAntiquityPending: false,
  actUpdateAntiquityError: null,
  actDeleteAntiquityPending: false,
  actDeleteAntiquityError: null,
  actPostAntiquityPending: false,
  actPostAntiquityError: null,
  actGetConfigsPending: false,
  actGetConfigsError: null,
  actUpdateConfigsPending: false,
  actUpdateConfigsError: null,
  actUpdateQuotePending: false,
  actUpdateQuoteError: null,
  actPostCompanySegmentPending: false,
  actPostCompanySegmentError: null,
  actPatchCompanySegmentPending: false,
  actPatchCompanySegmentError: null,
  actGetCategoriesPending: false,
  actGetCategoriesError: null,
  categories: [],
  reportFileCotizadorPending: false,
  reportFileCotizadorError: null,
  reportFileCotizadorSuccess: false,
}

export default initialState
